import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "../../i18n";
import { useLangSwitcher } from "../../lib/i18nRouting";

const LABEL = { ro: "RO", en: "EN", de: "DE", hu: "HU" };

/**
 * Elegant inline language selector — RO | EN | DE | HU.
 * Accepts a `tone` prop to adapt to dark/light headers.
 */
export default function LanguageSwitcher({ tone = "light", compact = false }) {
  const { i18n } = useTranslation();
  const switchTo = useLangSwitcher();
  const current = i18n.language;

  const base =
    tone === "dark"
      ? "text-bone/80"
      : "text-forest/80";
  const active =
    tone === "dark"
      ? "text-bone opacity-100"
      : "text-forest opacity-100";

  return (
    <div
      className={`flex items-center ${compact ? "gap-1.5" : "gap-2"} text-[11px] uppercase tracking-wider-3`}
      data-testid="lang-switcher"
      role="group"
      aria-label="Language selector"
    >
      {SUPPORTED_LANGS.map((l, i) => (
        <span key={l} className="flex items-center gap-2">
          {i > 0 && <span className={`opacity-30 ${tone === "dark" ? "text-bone" : "text-forest"}`}>·</span>}
          <button
            type="button"
            onClick={() => switchTo(l)}
            data-testid={`lang-btn-${l}`}
            aria-current={current === l ? "true" : "false"}
            className={`transition-colors duration-300 hover:opacity-100 ${
              current === l ? active : `${base} opacity-70`
            }`}
          >
            {LABEL[l]}
          </button>
        </span>
      ))}
    </div>
  );
}
